import { musicPlatformConstants } from "./constants/musicPlatformConstant";

const musicPlatformSave = (id:any, musicPlatformInput: any) => {
	return {
		type: musicPlatformConstants.MusicPlatformSaveRequest,
		input: {musicsInput: musicPlatformInput, id: id}
	};
};

const musicPlatformGetByFilter = (data:any) => {
	return {
		type: musicPlatformConstants.MusicPlatformGetByfilterRequest,
		input: data
	};
};
 
const musicPlatformGetDetail = (id: any) => {
	return {
		type: musicPlatformConstants.MusicPlatformDetailRequest,
		input: id
	};
};

const musicPlatformDelete = (id: any) => {
	return {
		type: musicPlatformConstants.MusicPlatformDeleteRequest,
		input: id
	};

};

export const MusicPlatformAction = {
	musicPlatformGetByFilter,
	musicPlatformGetDetail,
	musicPlatformSave,
	musicPlatformDelete
};